//#region module
import { useState } from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink, useNavigate,useLocation } from 'react-router-dom'
// material
import { styled } from '@mui/material/styles'
import { Drawer, Typography, List, ListItem, ListItemIcon, Box, Modal, Fade, Button } from '@mui/material'

// components
import Scrollbar from '../../components/Scrollbar'
import reportDashboardSidebarNewConfig from './ReportDashboardSideBarNewConfig'
import IconButton from '@mui/material/IconButton'
import { ReactComponent as BackArrowIcon } from "../../assets/icons/icon-back-arrow.svg"
import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';
import { DecryptData } from '../../utils/encryptDecrypt'
//#endregion

//#region CSS
const DRAWER_WIDTH = 145;
const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}))
//#endregion


export default function ReportDashboardSidebarNew({ isOpenSidebar, onCloseSidebar, onOpenSidebar, selectedSidebarMenu }) {
  const navigate = useNavigate();
  const [allowBackPopup, setAllowBackPopup] = useState(false)
  const search = useLocation().search;
  const pageNo = new URLSearchParams(search).get('pageNo'); 

  const handleSettingSelection = (menu) => {
    if (isOpenSidebar && selectedSidebarMenu === menu.title) {
      onCloseSidebar(menu)
    } else {
      onOpenSidebar(menu)
    }
  }

  const handleBackButton = (navigateTo) => {
    let DashboardHaveUnsavedChanges = DecryptData(localStorage.getItem('DashboardHaveUnsavedChanges'))

    if (DashboardHaveUnsavedChanges === true || DashboardHaveUnsavedChanges === 'true')
      setAllowBackPopup(true)
    else
      window.open(navigateTo, "_self")
  }

  const handleConfirmBack = (type, navigateTo) => {
    switch (type) {
      case 'cancel':
        setAllowBackPopup(false)
        break;
      case 'back':
        navigate(navigateTo)
        break;
    }

  }


  const renderContent = (
    <Scrollbar
      sx={{
        height: '100%',
        '& .simplebar-content': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      className="report-left-nav-scroll"
    >
      <List className="reports-left-nav">
        {reportDashboardSidebarNewConfig.map((menu, index) => (
          <ListItem
            button
            key={menu.title}
            className={`cm_rprt_sidebar report-new-sidebar-item ${selectedSidebarMenu === menu.title ? 'report_slctd_sidebar_menu' : ''}`}
            onClick={() => handleSettingSelection(menu)}
          >
            <ListItemIcon className="cm_rprt_sidebar_icon report-new-sidebar-item-icon">
              {menu.icon}
            </ListItemIcon>
            <Typography className="report-settings-text report-new-sidebar-item-text" variant="body2">
              {menu.title}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Scrollbar>
  )

  return (
    <RootStyle>
      <Drawer className="report-sidebar" variant="permanent" sx={{ width: DRAWER_WIDTH }}>
        <Box className="report-sidebar-back-btn" >
          <IconButton onClick={() => handleBackButton('/dashboard?pageNo='+pageNo)} className="report-new-back-button">
            <BackArrowIcon />
            <Typography variant="span" className="text-plain" sx={{ fontWeight: '500' }} pl={1} >Back</Typography>
          </IconButton>
        </Box>
        {renderContent}
      </Drawer>


      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={allowBackPopup}
        // onClose={() => setRestrictOption(false)}
        closeAfterTransition
      >
        <Fade in={allowBackPopup}>
          <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
            <Box className="modal-content-simple text-center" sx={{ p: '1rem !important' }}>
              <ErrorOutlineSharpIcon color="primary" />
              <Typography variant="subtitle1" className="text-plain font-weight-normal">Dashboard have some unsaved changes</Typography>

              <Box className="modal-footer">
                <Button onClick={() => handleConfirmBack('cancel')} color="error" className="report_form_ui_btn cancel mr-2" variant="outlined" > Stay on this Page </Button>
                <Button onClick={() => handleConfirmBack('back', '/dashboard')} color="error" className="report_form_ui_btn submit" variant="outlined"> Leave this Page </Button>
              </Box>
            </Box>

          </Box>
        </Fade>
      </Modal>
    </RootStyle>
  )
}

ReportDashboardSidebarNew.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
}